<template>

  <div class="compare-col">
    <div class="compare-block">
      <span class="icon-common-file-text-add"></span>

      <button class="button" @click="compareWithAnotherProfile()">
        Compare with Another Profile
      </button>
    </div>
  </div>

</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    
  },
})
export default class ComparePanel extends Vue {

  public compareWithAnotherProfile() {
    this.$store.commit('setModal', 'compare');
  }
  
}
</script>
<style scoped lang="scss">
</style>